import { cloneDeep as lodashCloneDeep } from 'lodash-es'

/**
 * Recursively clone an object
 */
export function cloneDeep<T>(value: T): T {
  return lodashCloneDeep(value)
}
